var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3NoRainCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 142.74 119.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: gray;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2162.53,
    y1: 15.05,
    x2: 2162.53,
    y2: 45.12,
    gradientTransform: "translate(2249.98) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 92.44,
    y1: 54.55,
    x2: 92.44,
    y2: 107.9,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.23,0c-8.39,0-16.15,3.72-21.32,9.98-.07-.02-.13-.03-.2-.05-.4-.11-.8-.22-1.2-.31-.09-.02-.19-.04-.28-.06-.48-.1-.97-.19-1.46-.27-.07,0-.14-.02-.2-.03-.42-.06-.84-.1-1.27-.14-.12-.01-.25-.02-.37-.03-.49-.03-.98-.05-1.48-.05-12.52,0-22.71,10.16-22.71,22.66,0,2.34.36,4.6,1.02,6.72-6.56-3.81-14.12-5.92-22.04-5.92C19.62,32.5,0,52.05,0,76.08c0,22.12,16.63,40.45,38.09,43.21l54.35.36c19.47,0,35.3-15.95,35.3-35.55,0-12.43-6.37-23.39-16-29.74h3.49s5.79-.61,5.79-.61c12.4-2.63,21.72-13.55,21.72-26.57,0-14.99-12.34-27.18-27.51-27.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m70.74,31.7c0,9.2,7.48,16.66,16.71,16.66h27.78c11.88,0,21.51-9.48,21.51-21.18s-9.63-21.18-21.51-21.18c-8.32,0-15.54,4.65-19.12,11.46-2.53-1.53-5.49-2.41-8.66-2.41-9.23,0-16.71,7.46-16.71,16.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 87.45,
    cy: 31.7,
    rx: 16.71,
    ry: 16.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m121.74,84.1c0,16.32-13.12,29.55-29.3,29.55h-48.71c-20.83,0-37.73-16.82-37.73-37.58s16.89-37.58,37.73-37.58c14.59,0,27.25,8.25,33.53,20.33,4.43-2.71,9.63-4.28,15.19-4.28,16.18,0,29.3,13.23,29.3,29.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 92.44,
    cy: 84.1,
    rx: 29.3,
    ry: 29.55
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3NoRainCloudy);
export default __webpack_public_path__ + "static/media/3-no-rain_cloudy.69e4225281b4bb47c2c28c1ecad1de47.svg";
export { ForwardRef as ReactComponent };